import { render, staticRenderFns } from "./RegistrarProyectoEmpresa.vue?vue&type=template&id=264f42e2&scoped=true&"
import script from "./RegistrarProyectoEmpresa.vue?vue&type=script&lang=js&"
export * from "./RegistrarProyectoEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarProyectoEmpresa.vue?vue&type=style&index=0&id=264f42e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f42e2",
  null
  
)

export default component.exports